import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {LoginService} from '../../../services/login.service';
import {User} from '../../../services/model/user';
import {Cookie} from "ng2-cookies/ng2-cookies";
import {GoogleAnalyticsService} from "../../../services/google-analytics-service";
import { TranslateService } from '@ngx-translate/core';
import {UtilsService} from '../../../services/utils.service';
import { BackendTranslateService } from '../../../helper/backend-translate.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})


export class SummaryComponent implements OnInit {

  ruid: string;
  summary: any = {};
  isLicense = true;
  currentUser: User = null;

  constructor(private apiService: ApiService,
              private ga: GoogleAnalyticsService,
              private route: ActivatedRoute,
              private loginService: LoginService,
              private notifications: NotificationsService,
              private translate: TranslateService,
              private utilsService: UtilsService,
              private backendTranslate: BackendTranslateService) {
  }

  ngOnInit() {
     this.currentUser = this.loginService.getCurrentUser();

    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.summary = res;
            this.isLicense = res.isLicense;
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
          });
      }
    });
  }

  downloadPDF() {
    this.ga.emitEvent('Reports Actions', 'Download PDF Report', 'Click');
    if (this.ruid) {
      const jsessionid = Cookie.get('JSESSIONID');
      window.open(environment.baseURL + `/api/report/pdf;jsessionid=${jsessionid}?ruid=` + this.ruid);
    }
  }
  
  public getFormatHTML(): string {
      return this.utilsService.decodeHtml(this.backendTranslate.translateMessage(this.summary.formatHTMLDescription));
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/summary/summary.component.ts